/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCareLiveAdmission } from './MatrixCareLiveAdmission';
import {
    MatrixCareLiveAdmissionFromJSON,
    MatrixCareLiveAdmissionFromJSONTyped,
    MatrixCareLiveAdmissionToJSON,
    MatrixCareLiveAdmissionToJSONTyped,
} from './MatrixCareLiveAdmission';

/**
 * 
 * @export
 * @interface FindAllMatrixCareHomeHealthAdmissionsResponse
 */
export interface FindAllMatrixCareHomeHealthAdmissionsResponse {
    /**
     * Complete for the admissions endpoint; copy-eligible only for copy-sources.
     * @type {Array<MatrixCareLiveAdmission>}
     * @memberof FindAllMatrixCareHomeHealthAdmissionsResponse
     */
    admissions: Array<MatrixCareLiveAdmission>;
    /**
     * MatrixCare's current admission after this read. Null on copy-sources.
     * @type {string}
     * @memberof FindAllMatrixCareHomeHealthAdmissionsResponse
     */
    current_admission_id: string | null;
}

/**
 * Check if a given object implements the FindAllMatrixCareHomeHealthAdmissionsResponse interface.
 */
export function instanceOfFindAllMatrixCareHomeHealthAdmissionsResponse(value: object): value is FindAllMatrixCareHomeHealthAdmissionsResponse {
    if (!('admissions' in value) || value['admissions'] === undefined) return false;
    if (!('current_admission_id' in value) || value['current_admission_id'] === undefined) return false;
    return true;
}

export function FindAllMatrixCareHomeHealthAdmissionsResponseFromJSON(json: any): FindAllMatrixCareHomeHealthAdmissionsResponse {
    return FindAllMatrixCareHomeHealthAdmissionsResponseFromJSONTyped(json, false);
}

export function FindAllMatrixCareHomeHealthAdmissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllMatrixCareHomeHealthAdmissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'admissions': ((json['admissions'] as Array<any>).map(MatrixCareLiveAdmissionFromJSON)),
        'current_admission_id': json['current_admission_id'],
    };
}

export function FindAllMatrixCareHomeHealthAdmissionsResponseToJSON(json: any): FindAllMatrixCareHomeHealthAdmissionsResponse {
    return FindAllMatrixCareHomeHealthAdmissionsResponseToJSONTyped(json, false);
}

export function FindAllMatrixCareHomeHealthAdmissionsResponseToJSONTyped(value?: FindAllMatrixCareHomeHealthAdmissionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'admissions': ((value['admissions'] as Array<any>).map(MatrixCareLiveAdmissionToJSON)),
        'current_admission_id': value['current_admission_id'],
    };
}

